import { render } from "./ActiveTab.vue?vue&type=template&id=9b1663ae"
import script from "./ActiveTab.vue?vue&type=script&lang=js"
export * from "./ActiveTab.vue?vue&type=script&lang=js"
script.render = render

export default script